import styled from 'styled-components'
import {
	media,
	Breakpoints,
	themeObject,
	textModels,
} from 'Pages/landings/newLandings/common/style'
import { ModalFullComponent } from 'Pages/landings/newLandings/common/components'
import { EditorJsWrapper } from 'Pages/admin/agreements/common/components/styled'

export const Modal = styled(ModalFullComponent)`
	font-family: 'SBSansText';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #373a44;
	${EditorJsWrapper} {
		.codex-editor__redactor {
			padding-bottom: 0px !important;
			${textModels('notAdaptive', 'm', '400')}
			color: ${themeObject.colors.grey[700]};
		}
		overflow: hidden;
		${media('overflow-y: auto;', Breakpoints.ms)}
	}
`
export const Agreement = styled.span<{ color?: string }>`
	cursor: pointer;
	color: ${({ color }) => color || themeObject.colors.brand[500]};
`
export const Politics = styled.a<{ color?: string }>`
	cursor: pointer;
	color: ${({ color }) => color || themeObject.colors.brand[500]};
`
export const Title = styled.p`
	${textModels('notAdaptive', 'm', '400')}
	color: ${themeObject.colors.grey[800]};
	margin-top: 16px;
	${media('margin: 0px 16px 0px 0px; flex-direction: row;', Breakpoints.ms)}
`
